<template>
  <div class="vip-page">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="会员类型">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option v-for="item in vipStatus" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="失效条件">
        <Select v-model="searchCondition.end_at" style="width:200px;" clearable>
          <Option v-for="item in loserday" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="昵称">
        <Input
          v-model="searchCondition.nickname"
          placeholder="请输入会员昵称关键字"
          style="width:200px;"
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">新增会员</Button>
      <Button type="primary" @click="onImport" class="btn-margin-right">批量导入</Button>
      <Button type="primary" @click="onExport('all')" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onWatch" class="btn-margin-right">查看报表</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColums"
        data-url="/api/vipUser"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="vip_id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.nickname"></span>
          </div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              @click="onForbidden(row)"
            >{{row.status == 1 ? '禁用' : '启用'}}</Button>
            <span>-</span>
            <Button type="text" size="small" @click="continueVip(row)">延长会员</Button>
            <span>-</span>
            <Button type="text" size="small" @click="del('one',row.vip_id)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" type="text" @click="del">删除所选</Button>
          <Button class="btn-margin-right" type="text" @click="onExport('select')">导出所选</Button>
        </template>
      </Grid>
    </div>
    <ExportsModal
      title="导出会员"
      :type="4"
      :params="exportForm"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></ExportsModal>
    <Modal v-model="showTimer" title="延长会员" :closable="false" :mask-closable="false">
      <Form
        ref="timer"
        :model="tiemrData"
        :rules="timerRules"
        :label-width="100"
        style="margin: 0 auto;"
      >
        <FormItem label="会员昵称：">
          <span>{{currentVip.nickname}}</span>
        </FormItem>
        <FormItem label="会员手机号：">
          <span>{{currentVip.mobile}}</span>
        </FormItem>
        <FormItem label="会员到期日：">
          <span>{{currentVip.vip_end_at}}</span>
        </FormItem>
        <FormItem label="延长至：" prop="vip_end_at">
          <DatePicker
            v-if="currentVip.vip_end_time"
            :start-date="currentVip.vip_end_time"
            :options="options"
            @on-change="settimer"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="请选择时间"
            style="width: 300px"
            :value="tiemrData.vip_end_at"
            :editable="false"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showTimer=false;currentVip={}">取消</Button>
        <Button type="primary" size="large" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ExportsModal from "@/components/ExportsModal";

export default {
  name: "MemberManager",
  components: {
    ExportsModal
  },
  data() {
    return {
      vipStatus: [{ key: "0", value: "禁用" }, { key: "1", value: "启用" }],
      loserday: [
        { key: "3", value: "3天内失效" },
        { key: "5", value: "5天内失效" },
        { key: "7", value: "7天内失效" },
        { key: "10", value: "10天内失效" }
      ],
      tableColums: [
        { title: "会员昵称", slot: "c1", minWidth: 200 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 150 },
        {
          title: "会员失效日期",
          key: "vip_end_at",
          align: "center",
          minWidth: 150
        },
        { title: "状态", key: "status_name", align: "center", minWidth: 100 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right"
        }
      ],
      searchCondition: {
        status: "",
        end_at: "",
        nickname: ""
      },
      selectRows: [],
      showExportModal: false,
      showTimer: false,
      exportForm: {},
      exportFormRules: {
        task_name: [{ required: true, message: "任务名称不能为空" }]
      },
      timerRules: {
        vip_end_at: [{ required: true, message: "请选择结束时间" }]
      },
      tiemrData: {
        vip_end_at: ""
      },
      currentVip: {},
      options: {
        disabledDate: date => {
          return date && date.valueOf() < this.currentVip.vip_end_at_utc;
        }
      }
    };
  },
  created() {},
  methods: {
    // on-event
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.vip_end_at_utc = i.vip_end_at * 1000;
        i.vip_end_time = new Date(i.vip_end_at * 1000 + 86000000);
        i.vip_end_at = this.$pub.timestampToTime(i.vip_end_at);
        i.status_name = i.status == 0 ? "禁用" : "正常";
      });
    },
    onSelectionChange(items) {
      this.selectRows = items;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.status = "";
      this.searchCondition.end_at = "";
      this.searchCondition.nickname = "";
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.$router.push({
        name: "MemberEdit"
      });
    },
    onImport() {
      this.$router.push({
        name: "MemberImport",
        query: {
          type: "vip"
        }
      });
    },
    onExport(row) {
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要导出的会员");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.vip_id);
        });
        this.exportForm.id = idAry.join();
      } else if (row == "all") {
        this.exportForm.status = this.searchCondition.status;
        this.exportForm.nickname = this.searchCondition.nickname;
        this.exportForm.end_at = this.searchCondition.end_at;
      }
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: "MemberExports",
        query: {
          type: "vip"
        }
      });
    },
    // 禁用/启用
    onForbidden(row) {
      if (row.status == 1) {
        this.$Modal.confirm({
          title: "提示",
          content:
            "禁用会员后该用户无法使用会员权限，再次启用后会员期限会相应顺延。确定禁用该会员么？",
          onOk: () => {
            this.$http.put("/api/vipUser/on/" + row.vip_id).then(() => {
              this.$refs.grid.searchRefresh();
            });
          }
        });
      } else {
        this.$http.put("/api/vipUser/on/" + row.vip_id).then(() => {
          this.$refs.grid.searchRefresh();
        });
      }
    },
    continueVip(row) {
      this.currentVip = row;
      this.tiemrData.vip_end_at = "";
      this.showTimer = true;
    },
    settimer(time) {
      this.tiemrData.vip_end_at = time;
    },
    del(_type, _id) {
      let ids = "";
      let status = 1;
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectRows.length == 0) {
          this.$Message.error("请至少选择一个");
          return false;
        } else {
          let arr = [];
          this.selectRows.forEach(i => {
            if (i.status == 0) {
              status = 0;
            }
            arr.push(i.vip_id);
          });
          ids = arr.join(",");
        }
      }
      if (status == 0) {
        this.$Modal.confirm({
          title: "删除",
          content:
            "<p>删除会员后该用户无法使用会员权限，确定要删除该会员吗？</p>",
          onOk: () => {
            this.delete(ids);
          },
          onCancel: () => {}
        });
      } else {
        this.$Message.error("不允许删除！");
        this.$refs.grid.searchRefresh();
      }
    },
    delete(_ids) {
      this.$http.delete(`/api/vipUser/${_ids}`).then(() => {
        this.$refs.grid.searchRefresh();
      });
    },
    submit() {
      this.$refs.timer.validate(val => {
        if (val) {
          this.$http
            .put(`/api/vipUser/${this.currentVip.vip_id}`, this.tiemrData)
            .then(() => {
              this.showTimer = false;
              this.$refs.grid.searchRefresh();
            });
        } else {
          this.$Message.error("输入有误，请检查!");
        }
      });
    }
    // other
    // request
  }
};
</script>